import { Outlet, useMatches, useNavigate } from 'react-router-dom';
import { Layout, Flex, Button, Breadcrumb, Select, App } from 'antd';
import { useContentContext } from './ContentContext';
import notify from '../../shared/utils/notify';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ProjectVersionPicker } from './_shared/ProjectPicker';

const { Content } = Layout;


export default function WithDetailLayout({ 
  children, 
  backTo = '/content', 
  title = 'Раздел', 
  subtitle = 'Просмотр',
  picker = true, // Показывать ли ProjectVersionPicker
}) {
  const navigate = useNavigate();

  return (
    <>
      <div className="px-4 md:px-6 pt-2">
        {/* Хлебные крошки Ant Design */}
        <Breadcrumb
          className="text-xs mb-2"
          items={[
            { title: 'Game Content' },
            { title: title },
            { title: 'Детали' },
          ]}
        />

        {/* Навигационная панель деталей */}
        <Flex orientation="horizontal" gap="large" justify="space-between" align="center">
          <Flex align="center" gap="middle">
            <Button 
              type="text" 
              shape="circle" 
              icon={<ArrowLeftOutlined />} 
              onClick={() => navigate(backTo)} 
            />
            <div>
              <h1 className="text-xl font-bold text-text-primary leading-tight">
                {subtitle}
              </h1>
            </div>
          </Flex>
          {picker && <ProjectVersionPicker />}
        </Flex>
      </div>

      {/* Основной контент страницы деталей */}
      <Content className="px-4 md:px-6 mt-4">
        {children} {/* Рендерим переданный компонент страницы напрямую */}
      </Content>
    </>
  );
}
